<script lang="ts">
  import { onMount } from 'svelte';
  
  // Получаем состояние VPN из родительского компонента
  // через контекст или свойства, если это будет необходимо в будущем
  
  // Данные о тарифных планах
  const plans = [
    {
      id: 'monthly',
      name: 'Месячный',
      price: 399,
      duration: '1 месяц',
      discount: '0%',
      popular: false,
      features: [
        'Доступ ко всем серверам',
        'До 10 устройств',
        'Высокая скорость',
        'Техническая поддержка',
        'Без ограничения трафика'
      ]
    },
    {
      id: 'semi-annual',
      name: 'Полугодовой',
      price: 350,
      fullPrice: 2099,
      duration: '6 месяцев',
      discount: '22%',
      popular: true,
      features: [
        'Доступ ко всем серверам',
        'До 10 устройств',
        'Максимальная скорость',
        'Приоритетная поддержка',
        'Без ограничения трафика'
      ]
    },
    {
      id: 'annual',
      name: 'Годовой',
      price: 276,
      fullPrice: 3360,
      duration: '1 год',
      discount: '39%',
      popular: false,
      features: [
        'Доступ ко всем серверам',
        'До 10 устройств',
        'Максимальная скорость',
        'Приоритетная поддержка',
        'Без ограничения трафика'
      ]
    },
    {
      id: 'biennial',
      name: 'Двухлетний',
      price: 187,
      fullPrice: 4560,
      duration: '2 года',
      discount: '58%',
      popular: false,
      features: [
        'Доступ ко всем серверам',
        'До 10 устройств',
        'Максимальная скорость',
        'VIP поддержка',
        'Без ограничения трафика',
        'Эксклюзивные функции'
      ]
    }
  ];
</script>

<section class="pricing" id="pricing">
  <div class="container">
    <h2 class="section-title">Тарифные планы</h2>
    <p class="section-subtitle">Выберите подходящий план для защиты вашей приватности</p>
    
    <div class="pricing-grid">
      {#each plans as plan}
        <div class="pricing-card {plan.popular ? 'popular' : ''}">
          {#if plan.popular}
            <div class="popular-badge">Популярный</div>
          {/if}
          
          <h3 class="plan-name">{plan.name}</h3>
          
          <div class="plan-price">
            <span class="currency">₽</span>
            <span class="amount">{plan.price}</span>
            <span class="period">/мес</span>
          </div>
          
          {#if plan.fullPrice}
            <div class="full-price">
              <span class="full-amount">₽{plan.fullPrice}</span> за {plan.duration}
            </div>
          {/if}
          
          {#if plan.discount !== '0%'}
            <div class="discount">Скидка {plan.discount}</div>
          {/if}
          
          <ul class="features-list">
            {#each plan.features as feature}
              <li class="feature-item">{feature}</li>
            {/each}
          </ul>
          
          <a href="#checkout" class="btn btn-primary btn-plan">Выбрать</a>
        </div>
      {/each}
    </div>
    
    <div class="payment-methods">
      <p class="payment-title">Принимаем различные способы оплаты</p>
      <div class="payment-icons">
        <span class="payment-icon">Visa</span>
        <span class="payment-icon">Mastercard</span>
        <span class="payment-icon">MIR</span>
        <span class="payment-icon">Bitcoin</span>
        <span class="payment-icon">USDT</span>
      </div>
    </div>
  </div>
</section>

<style>
  .pricing {
    padding: 6rem 0;
  }
  
  .section-title {
    font-size: 2.5rem;
    text-align: center;
    margin-bottom: 1rem;
  }
  
  .section-subtitle {
    font-size: 1.25rem;
    text-align: center;
    max-width: 600px;
    margin: 0 auto 3rem;
    opacity: 0.8;
  }
  
  .pricing-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
    margin-bottom: 3rem;
  }
  
  .pricing-card {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 0.75rem;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    position: relative;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    border: 1px solid rgba(255, 69, 0, 0.2);
  }
  
  .pricing-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(255, 69, 0, 0.1);
  }
  
  .pricing-card.popular {
    border-color: var(--sauron-red);
    transform: scale(1.05);
  }
  
  .popular-badge {
    position: absolute;
    top: -12px;
    right: 20px;
    background-color: var(--sauron-red);
    color: white;
    padding: 0.25rem 1rem;
    border-radius: 1rem;
    font-size: 0.875rem;
    font-weight: 600;
  }
  
  .plan-name {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    text-align: center;
  }
  
  .plan-price {
    font-size: 3rem;
    text-align: center;
    font-weight: 700;
    margin-bottom: 0.5rem;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 0.25rem;
  }
  
  .currency {
    font-size: 1.5rem;
    font-weight: 600;
    margin-top: 0.5rem;
  }
  
  .period {
    font-size: 1rem;
    font-weight: 400;
    opacity: 0.7;
    margin-top: 1rem;
  }
  
  .full-price {
    text-align: center;
    margin-bottom: 1.5rem;
    font-size: 0.875rem;
    opacity: 0.8;
  }
  
  .full-amount {
    font-weight: 600;
  }
  
  .discount {
    text-align: center;
    background-color: rgba(255, 69, 0, 0.1);
    color: var(--sauron-red);
    padding: 0.25rem 0.75rem;
    border-radius: 1rem;
    font-size: 0.875rem;
    font-weight: 600;
    width: fit-content;
    margin: 0 auto 1.5rem;
  }
  
  .features-list {
    list-style: none;
    padding: 0;
    margin: 0 0 2rem;
    flex-grow: 1;
  }
  
  .feature-item {
    padding: 0.5rem 0;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    opacity: 0.8;
  }
  
  .feature-item::before {
    content: "✓";
    color: var(--sauron-red);
    font-weight: bold;
  }
  
  .btn-plan {
    margin-top: auto;
    width: 100%;
    text-align: center;
  }
  
  .payment-methods {
    text-align: center;
  }
  
  .payment-title {
    font-size: 1.125rem;
    margin-bottom: 1rem;
    opacity: 0.8;
  }
  
  .payment-icons {
    display: flex;
    justify-content: center;
    gap: 1.5rem;
    flex-wrap: wrap;
  }
  
  .payment-icon {
    font-size: 1rem;
    opacity: 0.7;
  }
  
  /* Стили для режима Шира */
  :global(body.shire-mode) .pricing-card {
    background-color: rgba(255, 255, 255, 0.2);
    border-color: rgba(34, 139, 34, 0.2);
  }
  
  :global(body.shire-mode) .pricing-card.popular {
    border-color: var(--shire-green);
  }
  
  :global(body.shire-mode) .popular-badge {
    background-color: var(--shire-green);
  }
  
  :global(body.shire-mode) .discount {
    background-color: rgba(34, 139, 34, 0.1);
    color: var(--shire-green);
  }
  
  :global(body.shire-mode) .feature-item::before {
    color: var(--shire-green);
  }
  
  /* Адаптивная версия для мобильных */
  @media (max-width: 768px) {
    .pricing-grid {
      grid-template-columns: 1fr;
    }
    
    .pricing-card.popular {
      transform: scale(1);
    }
  }
</style>